// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IntakeIsHcpIntakeAllowedDefaultResponse {
    static getAttributeTypeMap() {
        return IntakeIsHcpIntakeAllowedDefaultResponse.attributeTypeMap;
    }
}
IntakeIsHcpIntakeAllowedDefaultResponse.discriminator = undefined;
IntakeIsHcpIntakeAllowedDefaultResponse.additionalProperties = false;
IntakeIsHcpIntakeAllowedDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IsHcpIntakeAllowedResponseModel"
    },
];
//# sourceMappingURL=intakeIsHcpIntakeAllowedDefaultResponse.js.map